<template>
  <div class="app">
    <scroll>
      <hospital-select @selected="selectHospital"></hospital-select>
      <voucher-select
        :list="voucherList"
        @selected="selectVoucher"
      ></voucher-select>
      <section class="thick" style="margin-top: 0.3rem">
        <ul class="tab-top">
          <li
            @click="onSelectedTab(index)"
            v-for="(item, index) in tabs"
            class="tab-item"
            :id="'register-departDoctor-tab-' + item.tabId"
            :class="{ active: selectedTab.tabId == item.tabId }"
          >
            <span class="tab-label">{{ item.tabName }}</span>
          </li>
        </ul>
      </section>
      <div>
        <ul class="wait-list" v-for="(item, index) in waitInfo">
          <li>
            <span class="left">科室/诊室</span>
            <span class="right">{{ item.deptName }}</span>
          </li>
          <li>
            <span class="left">就诊医生</span>
            <span class="right">{{ item.doctName }}</span>
          </li>
          <li>
            <span class="left">正在就诊号</span>
            <span class="right">{{ item.currentNo }}</span>
          </li>
          <li>
            <span class="left">我的就诊号</span>
            <span class="right"
              >{{ item.waitNo }}号
              <span
                v-if="item.status == '1'"
                :class="{ green: item.status == '1' }"
                >(等待中)</span
              >
              <span
                v-if="item.status == '2'"
                :class="{ green: item.status == '2' }"
                >(叫号中)</span
              >
              <span
                v-if="item.status == '3'"
                :class="{ gray: item.status == '3' }"
                >(过号)</span
              >
            </span>
          </li>
        </ul>
      </div>
      <no-record
        id="myregister-norecord"
        :condition="waitInfo"
        tips="抱歉，没有候诊记录"
      ></no-record>
    </scroll>
  </div>
</template>

<script>
import queryVoucher from 'voucher.service'
import HospitalSelect from 'HospitalSelect'
import VoucherSelect from 'VoucherSelect'
import queryFunList from 'queryFunList.service'
import NoRecord from 'NoRecord'
export default {
  components: {
    HospitalSelect,
    VoucherSelect,
    NoRecord
  },
  data () {
    return {
      voucherList: [],
      voucher: {
        cardNo: '',
        cardType: '',
        holderName: '',
        hospitalName: ''
      },
      tabs: [{
        tabName: '门诊',
        tabId: '1',
      }, {
        tabName: '检查',
        tabId: '2',
      }, {
        tabName: '检验',
        tabId: '3',
      }],
      selectedTab: {
        tabId: '1'
      },
      waitInfo: []
    }
  },
  mounted () {
    this.messagePush();
  },
  methods: {
    messagePush () {
      var query = this.$router.currentRoute.query;
      //区分消息推送和正常页面跳转
      if (query.cardNo) {
        //设置医院消息头和localStorage
        const hospital = {
          "hospitalId": query.hospitalId,
          "hospitalIndex": query.hospitalIndex,
          "hospitalName": query.hospitalName,
          "hospitalType": query.hospitalType
        };
        localStorage.selectedHospital = JSON.stringify(hospital);
        window.http.headers.common['hospitalId'] = hospital.hospitalId;
      }
      this.loadVouchers();
    },
    loadVouchers () {
      // 获取用户就诊凭证
      queryVoucher.getVoucherList().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }

        const data = res.data;
        if (data.length === 0) {
          this.$utils.alert('请先绑定诊疗卡');
          return;
        }
        this.voucherList = data;
        // 首次进入，默认第一张诊疗卡信息
        this.voucher = JSON.parse(JSON.stringify(this.voucherList[0]));

        // 保存默认卡信息
        this.$store.commit('updateParam', {
          namespace: 'mypay',
          voucher: this.voucher,
        });
        this.refresh();
      });
    },
    refresh () {
      //处理初始进入微信的未选医院情况
      if (typeof (http.headers.common['hospitalId']) == "undefined") {
        this.$utils.alert("请选择医院");
        return
      }
      //处理未绑定就诊凭证
      if (!this.voucher.cardType || !this.voucher.cardNo) {
        return this.$utils.alert('请先绑定诊疗卡')
      }
      this.getWaitInfo(this.selectedTab.tabId)
    },
    //选择就诊凭证
    selectVoucher (v) {
      this.voucher = v;

      //保存默认卡信息
      this.$store.commit('updateParam', {
        namespace: 'mypay',
        voucher: v
      });
      //加载默认卡的待缴费列表
      this.refresh();
    },
    //选择医院
    selectHospital () {
      this.refresh();
    },
    onSelectedTab (index) {
      this.selectedTab.tabId = this.tabs[index].tabId
      this.waitInfo = []
      this.getWaitInfo(index + 1)
    },
    getWaitInfo (index) {
      queryFunList.getWaitInfo({
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo,
        type: index,
      }).then((res) => {
        if (res.data.length === 0) {
          this.waitInfo = []
          return
        }
        this.waitInfo = res.data
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.app {
  background-color: #eff3f6;
  .wait-list {
    margin: 0.3rem 0;
    background-color: #fff;
    li {
      height: 2rem;
      line-height: 2rem;
      display: flex;
      justify-content: space-between;
      padding: 0 0.85rem;
      border-bottom: 0.05rem solid #f0f1f5;
      &:last-child {
        border: none;
      }
      .left {
        color: #a2a2a2;
      }
      .right {
        .green {
          color: #57d3ba;
        }
        .gray {
          color: #808080;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// WaitDoctor.vue?527f7914